export default __webpack_public_path__ + "static/media/caera01.034f3546.webm";